<main>
  <section class="bg-light-grey text-black-70 d-flex align-items-center">
    <div class="container">
      <div class="d-flex justify-content-between">
        <h1 class="p-2 h3 mb-0">Contact Us</h1>
        <div class="ms-auto p-2">
          <a class="btn btn-success text-white" href="tel:021-750-7886"><img src="../assets/img/local_phone-white-24dp.svg" alt="Phone" /> 021 750-7886</a>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-image-bar" style="background-image: url(https://picsum.photos/id/1/900/400);">
    <div class="container">
      <div class="bg-image-bar-info bg-dark-blue">
        <div>
          <h2>Contact Microtek</h2>
          <p class="pt-2">
            Microtek has more than hundred customers in indonesia with over 30 years of experience helping business succeed.
            Let us help you, too.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="bg-light-grey text-black-70 py-3">
    <div class="container">
      <div class="d-flex flex-column">
        <div class="text-center pb-2">
          <h3>How can we help you today?</h3>
        </div>
      </div>
      <div class="card-group d-flex flex-wrap gap-3">
        <!-- Email -->
        <div class="card border-0 bg-dark-blue flex-fill" style="min-width: 16rem;">
          <div class="d-flex justify-content-center">
            <img class="card-img-top py-4" style="width: 10rem;" src="../assets/img/sage-crowd-white.svg" alt="People" />
          </div>
          <div class="card-body text-white px-4">
            <h4 class="card-title">Need help with your sage solution? Find the answer you need quickly</h4>
            <p class="card-text py-4">
              <button type="button" class="btn btn-outline-light fw-bold" (click)="open(content)">Contact Support</button>
            </p>
          </div>
        </div>

        <!-- Phone -->
        <div class="card border-0 bg-dark-blue flex-fill" style="min-width: 16rem;">
          <div class="d-flex justify-content-center">
            <img class="card-img-top py-4" style="width: 10rem;" src="../assets/img/sage-people-chat-white.svg" alt="People" />
          </div>
          <div class="card-body text-white px-4">
            <div class="card-title d-flex flex-column gap-1">
              <h4>Contact Number</h4>
              <h5>021 766-0349</h5>
              <strong>Our Opening Hours</strong>
              <ul class="list-unstyled mb-0">
                <li>Monday to Friday</li>
                <li>8am-5PM</li>
                <li>Close on Public Holidays</li>
              </ul>
            </div>
            <p class="card-text py-4">
              <a href="tel:021-766-0349" class="btn btn-outline-light text-white fw-bold">Call Us</a>
            </p>
          </div>
        </div>

        <!-- Location -->
        <div class="card border-0 bg-dark-blue flex-fill" style="min-width: 16rem;">
          <div class="d-flex justify-content-center">
            <img class="card-img-top py-4" style="width: 10rem;" src="../assets/img/sage-business-scale-white.svg" alt="People" />
          </div>
          <div class="card-body text-white px-4">
            <div class="card-title">
              <h4>Our Location</h4>
              <address>
                <strong>Microtek Informa Solusindo</strong>
                <br />Golden Plaza Block E-15
                <br />R.S Fatmawati - 15
                <br />RT.8/RW.6
                <br />Cilandak
                <br />Jakarta Selatan 12420
                <br />Indonesia
              </address>
            </div>
            <p class="card-text py-4">
              <a href="https://goo.gl/maps/CCCw3RN6jsYqLaXu5" target="_blank" rel="noopener noreferrer" class="btn btn-outline-light text-white fw-bold">Direction</a>
            </p>
          </div>
        </div>

      </div>
    </div>
  </section>
</main>

<ng-template #content let-modal>
  <div class="modal-header">
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <app-emailus (onSucceed)="onSucceed($event)"></app-emailus>
  </div>
</ng-template>
